import styled from 'styled-components';
import Card from './card/Card';
import { SearchResults } from '../types';
import CardSkeleton from './card/CardSkeleton';
import NoResultsIndicator from '../../../new-components/NoResultsIndicator';
import { resetFilters } from '../../../helpers/search-filters';
import { useRouter } from 'next/router';
import { useContext } from 'react';
import {
  SearchContext,
  SearchContextInterface
} from '../context/SearchContext';
import { useSelector } from 'react-redux';
import { isEqual } from '../../../helpers/isEqual';
import AffordabilityBanner from './affordability-calculator/AffordabilityBanner';
import { injectComponentBetweenRows } from '../../../helpers/common';

interface CardsContainerProps {
  searchResults: SearchResults;
}
const CardsContainer = ({ searchResults }: CardsContainerProps) => {
  const router = useRouter();
  const { searchFiltersDispatch } = useContext(
    SearchContext
  ) as SearchContextInterface;
  const isFetching = useSelector(
    (state: any) => state.searchResults.searchResults.isFetching,
    isEqual
  );
  const isMobile = useSelector((state: any) => state.app.isMobile);

  const mappedResults =
    isMobile && searchResults && router.asPath.includes('/search')
      ? injectComponentBetweenRows(
          searchResults?.map((result, index) => (
            <Card key={result.id} searchResult={result} index={index} />
          )),
          <AffordabilityBanner key={'affordability-banner'} />,
          1
        )
      : searchResults?.map((result, index) => (
          <Card key={result.id} searchResult={result} index={index} />
        ));

  if (searchResults?.length == 0) {
    return (
      <NoResultsIndicator
        onClick={() => resetFilters(router, searchFiltersDispatch, false)}
        isResetButton={true}
      />
    );
  }

  return (
    <Container>
      {mappedResults}
      {isFetching && (
        <>
          <CardSkeleton />
          <CardSkeleton />
          <CardSkeleton />
        </>
      )}
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export default CardsContainer;
